<template>
  <div id="container">
    <div class="top-wrapper">
      <div class="top-inner">
        <logo />
        <menuView />
      </div>
    </div>
    <router-view />
    <footerView />
  </div>
</template>
<script>
import Logo from "@/components/Logo/Logo.vue";
import MenuView from "@/components/Menu/Menu.vue";
import FooterView from "@/components/Footer/Footer.vue";
// @ is an alias to /src

export default {
  name: "App",
  components: {
    Logo,
    MenuView,
    FooterView
  }
};
</script>
<style lang="scss">
#container {
  .top-wrapper {
    width: 100%;
    min-height: 100px;
    position: fixed;
    top: 0;
    left: 0;
    background: var(--color-light-1);
    border-bottom: 1px solid var(--color-light-5);
    z-index: 100;
    padding: 0 30px;
  }
  .top-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    max-width: 1440px;
    margin: 0 auto;
  }
}
</style>
